import React from 'react';
import { Text, View } from 'react-native';
import { useAppSelector } from '../../../store/hooks';
import { selectGlobalSeenScenarios } from '../../../store/slices/AdvanceSlice';
import { ScenesReplay } from './replayScenes/ScenesReplay';

interface ScenesProps {

}

export const Achievements: React.FC<ScenesProps> = ({ }) => {
    const globalSeenScenarios = useAppSelector(selectGlobalSeenScenarios);
    return (
        // <View>
            <ScenesReplay></ScenesReplay>
        // </View>
    );
};